import React from "react";
import "./Footer.css";
export default function Footer() {
  return (
    <div className="Footer text-center">
      <a
        href="https://github.com/sofijaV/weather-react"
        target="_blank"
        rel="noopener noreferrer"
      >
        Open source-code
      </a>{" "}
      created by Sofija
    </div>
  );
}
